import React, { useEffect, useRef } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Mission from "./components/Mission";
import WhyUs from "./components/WhyUs";
import ParentBenefits from "./components/ParentBenefits";
import Results from "./components/Results";
import MyStory from "./components/MyStory";
import Reviews from "./components/NewReviews";
import Contact from "./components/Contact";
import LaunchPad from "./components/LaunchPad";
import Process from "./components/Process";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import logo from "./assets/Main Logo.jpg";
import "./Styles/LaunchPadCallout.css";
import "./Styles/App.css";

function HomePage() {
  const missionRef = useRef(null);
  const whyUsRef = useRef(null);
  const benefitsRef = useRef(null);
  const resultsRef = useRef(null);
  const processRef = useRef(null);
  const myStoryRef = useRef(null);
  const reviewsRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (section) => {
    const map = {
      mission: missionRef,
      whyUs: whyUsRef,
      benefits: benefitsRef,
      results: resultsRef,
      reviews: reviewsRef,
      process: processRef,
      myStory: myStoryRef,
      contact: contactRef,
    };
    const target = map[section]?.current;
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    const nodes = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right, .reveal-scale"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -36px 0px" }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="app-shell">
      <Header scrollToSection={scrollToSection} />
      <main className="page-main">
        <Hero scrollToSection={scrollToSection} />

        <div className="trust-bar">
          <ul className="container trust-bar-list">
            <li>
              <strong>Calgary &amp; Airdrie</strong>
              Local support for Alberta families
            </li>
            <li>
              <strong>25+ students weekly</strong>
              Personalized one-on-one tutoring
            </li>
            <li>
              <strong>University tutors</strong>
              Carefully matched to your child
            </li>
          </ul>
        </div>

        <div ref={missionRef}>
          <Mission />
        </div>

        <div ref={whyUsRef}>
          <WhyUs />
        </div>

        <div ref={benefitsRef}>
          <ParentBenefits scrollToSection={scrollToSection} />
        </div>

        <div ref={resultsRef}>
          <Results scrollToSection={scrollToSection} />
        </div>

        <div ref={processRef}>
          <Process scrollToSection={scrollToSection} />
        </div>

        <section className="mid-cta">
          <div className="container mid-cta-inner">
            <div>
              <h2>Ready for calmer evenings and clearer progress?</h2>
              <p>
                Book a free intro call. We’ll listen first, then help you decide if True Bloom is the right fit for your family.
              </p>
            </div>
            <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
              Book Free Intro Call
            </button>
          </div>
        </section>

        <div ref={reviewsRef}>
          <Reviews />
        </div>

        <div ref={myStoryRef}>
          <MyStory scrollToSection={scrollToSection} />
        </div>

        <div ref={contactRef}>
          <Contact />
        </div>

        <section className="home-launchpad">
          <div className="container home-launchpad-inner">
            <div>
              <h2>Looking to tutor instead?</h2>
              <p>
                University students can apply to True Bloom LaunchPad — our selective training and hiring program.
              </p>
            </div>
            <Link to="/launchpad" className="btn btn-dark">
              Explore LaunchPad
            </Link>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <div className="container footer-grid">
          <div className="footer-brand">
            <div className="footer-brand-mark">
              <img src={logo} alt="True Bloom Tutoring logo" />
              <strong>
                True Bloom
                <span>Tutoring</span>
              </strong>
            </div>
            <p>
              Personalized tutoring that helps Calgary &amp; Airdrie students rebuild confidence and reach their goals.
            </p>
          </div>
          <div className="footer-col">
            <h3>Explore</h3>
            <ul>
              <li>
                <button onClick={() => scrollToSection("whyUs")}>Why Us</button>
              </li>
              <li>
                <button onClick={() => scrollToSection("results")}>Results</button>
              </li>
              <li>
                <button onClick={() => scrollToSection("process")}>How It Works</button>
              </li>
              <li>
                <button onClick={() => scrollToSection("contact")}>Contact</button>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h3>Contact</h3>
            <ul>
              <li>
                <a href="tel:+15875746444">(587) 574-6444</a>
              </li>
              <li>
                <a href="mailto:truebloomtutoring@gmail.com">truebloomtutoring@gmail.com</a>
              </li>
              <li>
                <Link to="/launchpad">LaunchPad for tutors</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="container footer-bottom">
          <span>© {new Date().getFullYear()} True Bloom Tutoring</span>
          <span>Calgary &amp; Airdrie, Alberta</span>
        </div>
      </footer>

      <div className="sticky-cta" aria-label="Quick contact">
        <a className="btn btn-secondary" href="tel:+15875746444">
          Call Now
        </a>
        <button className="btn btn-primary" onClick={() => scrollToSection("contact")}>
          Book Intro Call
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/launchpad" element={<LaunchPad />} />
      </Routes>
    </Router>
  );
}

export default App;
